import Drawer from 'components/Drawer/Drawer'

import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'

import styles from './AmbulatoryQuote.module.sass'
import AmbulatoryQuoteTable from './AmbulatoryQuoteTable'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { getStateValueByTicketState } from 'components/cards/TicketCard/TicketCard'
import { Budget } from 'models'
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator'
import { useFetchList } from 'store'
import AmbulatoryQuoteTotalsTable from './AmbulatoryQuoteTotalsTable'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import TextInput from '@jimmyboys/liita-ui/dist/components/TextInput'

const DrawerHeader = ({ data }) => {
	return (
		<HStack justify='space-between' className={styles['drawer-header']}>
			<h5>{`#${data.id}`}</h5>
		</HStack>
	)
}

const AmbulatoryQuoteHeader = ({ data }) => {
	const { i18n } = useGlobal()

	const ticketStatusValue = getStateValueByTicketState(data?.ticketStatus?.id)

	return (
		<VStack className={styles['header']}>
			<h3>{i18n`Ambulatory Quote`}</h3>

			<h5
				className={`${styles['ticket-status']} ${
					styles[`status-${ticketStatusValue}`]
				}`}
			>
				{data?.ticketStatus?.description}
			</h5>

			<small>
				<p>{i18n`Requested at ${data.creationDate.shortDateFormat} by ${data.author}`}</p>
			</small>
			{data.responseUser && (
				<small>
					<p>{i18n`Submited at ${data.responseDate.shortDateFormat} by ${data.responseUser}`}</p>
				</small>
			)}
		</VStack>
	)
}

const AmbulatoryQuote = (props) => {
	const { handleClose, data: ticket } = props
	const { i18n } = useGlobal()

	const { state, contents } = useFetchList(
		[`/clinical_processes/${ticket.processId}/quote/tickets/${ticket.id}`],
		[Budget.fromJSON]
	)

	const [budget = {}] = contents

	const isLoading = state === 'loading'

	const noteValue = budget?.ticketObservations

	return (
		<Drawer
			dialogId={'drawer'}
			handleClose={handleClose}
			customHeader={<DrawerHeader data={ticket} />}
			backdrop={false}
			className={styles['drawer']}
		>
			{isLoading ? (
				<>
					<LoadingIndicator className={styles['--fade']} />
				</>
			) : (
				<div className={styles['root']}>
					<AmbulatoryQuoteHeader data={ticket} />

					<div className={styles['content']}>
						{budget === null ? (
							<strong>{i18n`No budget added for this ticket`}</strong>
						) : (
							<>
								<AmbulatoryQuoteTotalsTable
									sellPrice={budget?.sections?.total?.sellPrice?.toFixed(
										2
									)}
								/>

								<h4>{i18n`Details`}</h4>

								<AmbulatoryQuoteTable
									data={budget?.sections?.global}
									expandable
									strong
								/>

								<AmbulatoryQuoteTable
									data={budget?.sections?.requisitions}
									header={false}
								/>

								<AmbulatoryQuoteTable
									data={budget?.sections?.appointments}
									header={false}
								/>

								<AmbulatoryQuoteTable
									data={budget?.sections?.deductibles}
									header={false}
									expandable={false}
								/>
								<HStack
									justify='space-between'
									align='flex-end'
								>
									{noteValue !== '' ? (
										<div className={styles['notes-root']}>
											<div
												className={`
												${styles['note-container']}
												${styles['--from-maximized-to-without-options']}
											`}
											>
												<VStack>
													<HStack
														className={
															styles[
																'note-text-container'
															]
														}
													>
														<Icon
															width='20px'
															height='20px'
															name='note'
														></Icon>
														<VStack
															className={
																styles[
																	'text-container'
																]
															}
														>
															<h5>{i18n`Note`}</h5>
															<TextInput
																className={`${
																	styles[
																		'notes-input'
																	]
																} ${
																	noteValue
																		? styles[
																				'--has-text'
																		  ]
																		: ''
																}`}
																multiline={true}
																placeholder={i18n`Add a note`}
																rows={5}
																noResize
																value={
																	noteValue
																}
															/>
														</VStack>
													</HStack>
												</VStack>
											</div>
										</div>
									) : (
										<p></p>
									)}

									<HStack
										justify='flex-end'
										className={styles['total']}
									>
										<strong>
											{i18n`Total`}:{' '}
											{budget?.sections?.total?.sellPrice.toFixed(
												2
											)}
											€
										</strong>
									</HStack>
								</HStack>
							</>
						)}
					</div>
				</div>
			)}
		</Drawer>
	)
}

export default AmbulatoryQuote
